const imagesLoader = {
    "sieges": require.context("./assets/images/sieges", false, /\.(jpeg|png|PNG|php|JPG|jpg|webp|svg)$/),
    "abat-jour": require.context("./assets/images/abat-jour", false, /\.(jpeg|png|PNG|php|JPG|jpg|webp|svg)$/),
    "coussins": require.context("./assets/images/coussins", false, /\.(jpeg|png|PNG|php|JPG|jpg|webp|svg)$/),
}

export default imagesLoader;